/* NA LEIBERL – Produktseite: Farbkreise, Thumbnail-Leiste fuer Scroll-Galerie, Rabattcode kopieren, Groessentabelle oeffnen, Sticky-Warenkorb-Leiste */
(function () {
  // ---------- Farbkreise statt Text-Buttons ----------
  // Farbname (klein geschrieben) -> Farbwert. Neue Farben einfach hier ergaenzen.
  var NL_COLORS = {
    'weiß': '#FFFFFF', 'weiss': '#FFFFFF', 'white': '#FFFFFF',
    'schwarz': '#1C1A1B', 'black': '#1C1A1B',
    'marine': '#1F2A44', 'navy': '#1F2A44', 'dunkelblau': '#1F2A44', 'french navy': '#1F2A44',
    'blau': '#2F5DA8', 'blue': '#2F5DA8', 'royal': '#2B4FA3', 'royalblau': '#2B4FA3', 'hellblau': '#A9C6E8', 'sky blue': '#A9C6E8',
    'grau': '#9C9C9C', 'grey': '#9C9C9C', 'gray': '#9C9C9C', 'heather grey': '#B9B9B9', 'grau meliert': '#B9B9B9', 'sport grey': '#B9B9B9', 'hellgrau': '#D3D3D3',
    'anthrazit': '#3A3A3C', 'dark grey': '#3A3A3C', 'charcoal': '#3A3A3C', 'dunkelgrau': '#3A3A3C',
    'rot': '#C42A30', 'red': '#C42A30', 'bordeaux': '#6B1E2A', 'burgundy': '#6B1E2A', 'weinrot': '#6B1E2A',
    'grün': '#2E6B3F', 'gruen': '#2E6B3F', 'green': '#2E6B3F', 'flaschengrün': '#1F4A33', 'bottle green': '#1F4A33', 'oliv': '#6B6B3A', 'olive': '#6B6B3A', 'khaki': '#8A845C',
    'beige': '#D9C7A7', 'sand': '#D9C7A7', 'creme': '#F1EBDD', 'cream': '#F1EBDD', 'natur': '#EFE8D8', 'natural': '#EFE8D8', 'ecru': '#EFE8D8', 'off-white': '#F4F1E8',
    'braun': '#6B4A2F', 'brown': '#6B4A2F', 'gelb': '#F3D23B', 'yellow': '#F3D23B', 'orange': '#E8772E',
    'rosa': '#F2B6C6', 'pink': '#F2B6C6', 'lila': '#7A5C9E', 'purple': '#7A5C9E', 'flieder': '#C8B6E2'
  };
  var COLOR_LABEL = /^(farbe|color|colour)\b/i;
  var COLOR_KEYS = Object.keys(NL_COLORS).sort(function (a, b) { return b.length - a.length; });

  function colorFor(name) {
    var key = (name || '').trim().toLowerCase();
    if (NL_COLORS[key]) return NL_COLORS[key];
    // Teiltreffer, z. B. "Weiss / Vintage" oder "Heather Grey Melange"
    for (var i = 0; i < COLOR_KEYS.length; i++) { if (key.indexOf(COLOR_KEYS[i]) !== -1) return NL_COLORS[COLOR_KEYS[i]]; }
    return null;
  }

  function isLight(hex) {
    var h = hex.replace('#', '');
    var r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) > 215;
  }

  function buildSwatches() {
    var fieldsets = document.querySelectorAll('.product__info-container variant-selects fieldset');
    Array.prototype.forEach.call(fieldsets, function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend) return;
      var labelText = (legend.getAttribute('data-nl-label') || legend.textContent || '').trim();
      if (!COLOR_LABEL.test(labelText)) return;

      var inputs = fs.querySelectorAll('input[type=radio]');
      if (!inputs.length) return;
      var allMapped = true;
      Array.prototype.forEach.call(inputs, function (input) { if (!colorFor(input.value)) allMapped = false; });
      if (!allMapped) return; // unbekannte Farbe -> Text-Buttons behalten

      if (!fs.classList.contains('nl-swatches')) fs.classList.add('nl-swatches');
      Array.prototype.forEach.call(inputs, function (input) {
        var label = fs.querySelector('label[for="' + input.id + '"]');
        if (!label || label.classList.contains('nl-swatch')) return; // schon umgebaut
        var hex = colorFor(input.value);
        label.classList.add('nl-swatch');
        if (isLight(hex)) label.classList.add('nl-swatch--light');
        label.style.setProperty('--nl-swatch', hex);
        label.setAttribute('title', input.value);
        var txt = document.createElement('span');
        txt.className = 'nl-swatch__name visually-hidden';
        txt.textContent = input.value;
        Array.prototype.forEach.call(label.childNodes, function (n) { if (n.nodeType === 3 && n.textContent.trim()) n.textContent = ''; });
        label.appendChild(txt);
      });

      // "Farbe: Weiss" in der Ueberschrift (nur aendern, wenn sich etwas aendert -> keine Endlosschleife)
      var checked = fs.querySelector('input[type=radio]:checked');
      var val = legend.querySelector('.nl-swatch-value');
      if (!val) {
        var base = labelText.replace(/:.*$/, '').trim();
        legend.setAttribute('data-nl-label', base);
        legend.textContent = base + ': ';
        val = document.createElement('span');
        val.className = 'nl-swatch-value';
        legend.appendChild(val);
      }
      var want = checked ? checked.value : '';
      if (val.textContent !== want) val.textContent = want;
    });
  }

  // Theme rendert die Variantenauswahl bei jedem Wechsel neu -> Farbkreise erneut anwenden
  function watchVariantPicker() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;
    var scheduled = false;
    var mo = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; buildSwatches(); });
    });
    mo.observe(container, { childList: true, subtree: true });
    document.addEventListener('change', function (e) { if (e.target.closest('variant-selects')) buildSwatches(); });
  }

  // ---------- Rabattcode in die Zwischenablage kopieren ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nl-promo__code');
    if (!btn) return;
    var code = btn.getAttribute('data-code');
    try { if (navigator.clipboard) navigator.clipboard.writeText(code); } catch (err) {}
    btn.classList.add('is-copied');
    setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
  });

  // ---------- Link Groessentabelle: Akkordeon oeffnen und hinscrollen ----------
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-nl-open]');
    if (!link) return;
    var target = document.getElementById(link.getAttribute('data-nl-open'));
    if (!target) return;
    e.preventDefault();
    target.open = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // ---------- Galerie: Bilder untereinander + Thumbnail-Leiste links (Desktop) ----------
  var railObserver = null;
  function buildRail() {
    var wrapper = document.querySelector('.product--stacked .product__media-wrapper');
    if (!wrapper) return;
    var gallery = wrapper.querySelector('media-gallery');
    if (!gallery) return;
    var old = wrapper.querySelector('.nl-thumbs');
    if (old) old.remove();
    if (railObserver) { railObserver.disconnect(); railObserver = null; }

    var items = Array.prototype.filter.call(
      gallery.querySelectorAll('.product__media-list > .product__media-item'),
      function (li) { return li.offsetParent !== null || window.innerWidth < 990; }
    );
    if (items.length < 2) { wrapper.classList.remove('nl-has-thumbs'); return; }

    var rail = document.createElement('div');
    rail.className = 'nl-thumbs';
    rail.setAttribute('aria-label', 'Produktbilder');
    var buttons = [];
    items.forEach(function (li, i) {
      var img = li.querySelector('img');
      if (!img) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nl-thumbs__btn';
      b.setAttribute('aria-label', 'Bild ' + (i + 1) + ' anzeigen');
      var t = document.createElement('img');
      t.src = img.currentSrc || img.src;
      t.alt = '';
      t.loading = 'lazy';
      b.appendChild(t);
      b.addEventListener('click', function () { li.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      rail.appendChild(b);
      buttons.push({ li: li, btn: b });
    });
    wrapper.insertBefore(rail, gallery);
    wrapper.classList.add('nl-has-thumbs');
    if (buttons[0]) buttons[0].btn.classList.add('is-active');

    railObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        buttons.forEach(function (x) { x.btn.classList.toggle('is-active', x.li === en.target); });
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    buttons.forEach(function (x) { railObserver.observe(x.li); });
  }

  // ---------- Sticky-Warenkorb-Leiste (aktueller Preis + rechts daneben klein der alte Preis) ----------
  function initSticky() {
    var bar = document.querySelector('.nl-sticky-atc');
    var mainBtn = document.querySelector('.product__info-container .product-form__submit');
    if (!bar || !mainBtn) return;
    document.body.appendChild(bar);
    var variantEl = bar.querySelector('.nl-sticky-atc__variant');
    var priceEl = bar.querySelector('.nl-sticky-atc__price');
    var stickyBtn = bar.querySelector('.nl-sticky-atc__btn');

    var priceWrap = document.createElement('div');
    priceWrap.className = 'nl-sticky-atc__prices';
    priceEl.parentNode.insertBefore(priceWrap, priceEl);
    priceWrap.appendChild(priceEl);
    var oldEl = document.createElement('s');
    oldEl.className = 'nl-sticky-atc__old';
    priceWrap.appendChild(oldEl);

    function refresh() {
      var picked = Array.prototype.map.call(
        document.querySelectorAll('.product__info-container variant-selects input:checked, .product__info-container variant-selects select'),
        function (el) { return el.value; }
      ).filter(Boolean);
      variantEl.textContent = picked.join(' / ');

      var priceBox = document.querySelector('.product__info-container .price--large') || document.querySelector('.product__info-container .price');
      var onSale = priceBox && priceBox.classList.contains('price--on-sale');
      var current = priceBox && priceBox.querySelector(onSale ? '.price__sale .price-item--last' : '.price__regular .price-item--regular');
      var compare = onSale && priceBox.querySelector('.nl-old-price s.price-item, .price__sale s.price-item');
      priceEl.textContent = current ? current.textContent.trim() : '';
      oldEl.textContent = compare ? compare.textContent.trim() : '';
      oldEl.hidden = !compare;

      var btn = document.querySelector('.product__info-container .product-form__submit');
      stickyBtn.disabled = btn ? btn.disabled : false;
    }

    stickyBtn.addEventListener('click', function () {
      var btn = document.querySelector('.product__info-container .product-form__submit');
      if (btn && !btn.disabled) btn.click();
    });

    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (show) refresh();
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyBtn.tabIndex = show ? 0 : -1;
    });
    io.observe(mainBtn);
    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects')) setTimeout(refresh, 600);
    });
  }

  function init() {
    buildSwatches();
    watchVariantPicker();
    buildRail();
    initSticky();
    // Nach Variantenwechsel Bilderleiste neu aufbauen (Theme sortiert Bilder um)
    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects')) setTimeout(buildRail, 600);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
